 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		1: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		1: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/chunks/" + ({"0":"framework","3":"eae6f35fcab366852a77f1f00310047e04fe07b9","5":"c9c6fe98","6":"fb2645b55c16f7869af7a7384c4bc4476b00a5cf","8":"e8adfd52c7186b74a6407fd11eaa2191ed7e5545","10":"18d10a888c5ade3f35f8f4888e70ee4fc7b76990","11":"e378534f944924bb957cbff13fdb9e485009d68f","12":"75fc9c18","13":"cb587b6468196656336b0d2e9a2a1e3226ab0577","19":"1b71e3b478f54a1cc4850717986c2c1e9f96663e","20":"395aefadd6d3ca46d869d681072703731c097147","24":"f929a364fc82e5f5a75c1d52bff9d61721290ab0","28":"2f278f5933c8f8f7f1fc14fe08e98e65aa0ad710","31":"f31d4b40b0c9891021095bb9291d7071f3c344ca","37":"fb8e0a985f1e2798051d4965d984ea2bb1775ce2","41":"c8f7fe3b0e41be846d5687592cf2018ff6e22687","42":"cae5737e08c1a9948a650822c6a84ae1b82f4d13","43":"d282c9243d032fb2d2ee2da709a47048b1d844db","124":"reactPlayerDailyMotion","125":"reactPlayerFacebook","126":"reactPlayerFilePlayer","127":"reactPlayerKaltura","128":"reactPlayerMixcloud","129":"reactPlayerMux","130":"reactPlayerPreview","131":"reactPlayerSoundCloud","132":"reactPlayerStreamable","133":"reactPlayerTwitch","134":"reactPlayerVidyard","135":"reactPlayerVimeo","136":"reactPlayerWistia","137":"reactPlayerYouTube"}[chunkId]||chunkId) + "." + {"0":"c79e8c1855af7b4c66de","3":"0e99139bb943e2a2cf3a","5":"ab8791e390bc74b692b5","6":"0db9f40a5c4362777377","8":"b1448c5e908ba4423a27","10":"4677d80b9543c668c250","11":"02180ed975b8f5d6248f","12":"2eb2208f36119ea21c98","13":"e3e3c79cdc3092c3e9d3","19":"ba630170d832ec515a69","20":"1e4bb1d6b5e29c3fc6b2","24":"907b2520f9b1b227aab8","28":"b0b33273df997a7eb7af","31":"363dc8e35495744f84f0","37":"99ced1841c1f16ceca63","41":"9947bc3972a8148a5cbb","42":"9bcba0db7440a544fb5c","43":"26aeaafbcd5ecec9dda4","44":"9595ef57d18c735be81d","45":"37634c69928d22caa2a9","46":"7b87d977b34b9c4b761c","47":"b1eb6cde5eb5d4241e0f","48":"4ca5191aa13229fd367f","49":"3a3fd514bfef193aa0ce","50":"6123868a5d221baa80b9","51":"3084da069f2c28171f75","52":"42d0af24a300d3ffeb8a","54":"65d21e900650adb9cec2","55":"81c6ce527a947d1100ea","56":"de6a3d54394ba0e43a78","57":"5baf165b4d3ec00f1430","58":"bd8d9a73874604dfae4b","59":"a8e2847788bb5ae32538","60":"1f8365cfde14d23ada91","61":"329b3c195fa54c5cde96","62":"0178de391173138ecabe","71":"1896404ebb914bb8873b","72":"88b11ae3325c94f6e5d6","73":"ab669174ecd748f73aab","74":"e879c54b6470c5bf878c","75":"bba6d49fc5f3ccf5d164","124":"b29cee39e5517bc61487","125":"38e0442bd99c50def60f","126":"d031cf296a8b7f13819e","127":"30c310a11ff6e0636269","128":"c564491b4b1fbd3d0b03","129":"713be62eb4da9bea1c04","130":"9ee87f8ba4f564a079a8","131":"4a1b8bfee54f45d27e6f","132":"a20afef1c5dcb13e3d73","133":"ab00d4a247741ae4d7ef","134":"b1c291797e4cfc3c58a1","135":"0d8ab48cb99fe902a3dd","136":"87a4de9cb59d83e51de5","137":"c614da1168979e5d2cea","138":"e2ac8e6449566ee303f2","139":"c4f4d7f58cf5d8901ed6","140":"40fc5f39647c91f6137b","141":"59a3c4e49f5045a5c58f","142":"50ff143900b6fd4774bd","143":"82a9fbd97ef38c5834d4","144":"e9df1d99fe4d39d86f4f","145":"5142b65651b7e1cc7bd3","146":"61e5af72d33cc9b9dfce","147":"9d3f28e10f321541205a","148":"615bf76bc345ed150e36","149":"9e2f98cb9b6933ad9322","150":"bf8e073ea00788710885","151":"5831ac2872d6f9a2db42","152":"f1c684a456145471f28e","153":"dc3da298fd2372d3068e","154":"8acd4468bb67c324d687"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		var threw = true;
 		try {
 			modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
 			threw = false;
 		} finally {
 			if(threw) delete installedModules[moduleId];
 		}

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"45":1,"47":1,"48":1,"50":1,"54":1,"55":1,"56":1,"57":1,"59":1,"60":1,"61":1,"62":1,"71":1,"72":1,"138":1,"139":1,"141":1,"142":1,"143":1,"144":1,"145":1,"146":1,"147":1,"148":1,"149":1,"150":1,"153":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + {"0":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"dadbbbe91415178fd5b9","46":"31d6cfe0d16ae931b73c","47":"dc70aae7cf8fc7f2bccd","48":"8aea57c851ce806adcb8","49":"31d6cfe0d16ae931b73c","50":"dc70aae7cf8fc7f2bccd","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","54":"cd227cf232376756b27e","55":"dc70aae7cf8fc7f2bccd","56":"3ca7ebb4910ecccd7042","57":"56633a079c37d7786f83","58":"31d6cfe0d16ae931b73c","59":"3ca7ebb4910ecccd7042","60":"dc70aae7cf8fc7f2bccd","61":"41a9a328edd47a0b0e5c","62":"41a9a328edd47a0b0e5c","71":"3ca7ebb4910ecccd7042","72":"dc70aae7cf8fc7f2bccd","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c","124":"31d6cfe0d16ae931b73c","125":"31d6cfe0d16ae931b73c","126":"31d6cfe0d16ae931b73c","127":"31d6cfe0d16ae931b73c","128":"31d6cfe0d16ae931b73c","129":"31d6cfe0d16ae931b73c","130":"31d6cfe0d16ae931b73c","131":"31d6cfe0d16ae931b73c","132":"31d6cfe0d16ae931b73c","133":"31d6cfe0d16ae931b73c","134":"31d6cfe0d16ae931b73c","135":"31d6cfe0d16ae931b73c","136":"31d6cfe0d16ae931b73c","137":"31d6cfe0d16ae931b73c","138":"cd227cf232376756b27e","139":"cd227cf232376756b27e","140":"31d6cfe0d16ae931b73c","141":"dadbbbe91415178fd5b9","142":"3ca7ebb4910ecccd7042","143":"cd227cf232376756b27e","144":"56633a079c37d7786f83","145":"dc70aae7cf8fc7f2bccd","146":"3ca7ebb4910ecccd7042","147":"dc70aae7cf8fc7f2bccd","148":"8aea57c851ce806adcb8","149":"dc70aae7cf8fc7f2bccd","150":"41a9a328edd47a0b0e5c","151":"31d6cfe0d16ae931b73c","152":"31d6cfe0d16ae931b73c","153":"dc70aae7cf8fc7f2bccd","154":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
